import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.136 6.235A9.74 9.74 0 0 1 12 2.25a9.72 9.72 0 0 1 6.696 2.663c-.397.04-.752.157-1.056.352a2.13 2.13 0 0 0-.797.936c-.308.689-.267 1.486-.043 2.069.199.515.403.894.593 1.211.076.128.14.232.2.327.099.159.18.288.261.446.207.394.385.905.396 2.126l-1.265 3.793-2.93-8.423h.445a.75.75 0 0 0 0-1.5h-5a.75.75 0 0 0 0 1.5h.482l1.386 3.652-1.766 5.058-3.04-8.71H7a.75.75 0 0 0 0-1.5H5.648a1 1 0 0 0-.148-.015zM2.788 8.8A9.7 9.7 0 0 0 2.25 12a9.75 9.75 0 0 0 4.914 8.468L2.788 8.798ZM9.46 21.416a9.8 9.8 0 0 0 2.539.334 9.7 9.7 0 0 0 3.102-.504l-2.907-7.663zm7.748-1.173A9.74 9.74 0 0 0 21.75 12a9.7 9.7 0 0 0-.636-3.47L17.21 20.242ZM12 .75C5.787.75.75 5.787.75 12S5.787 23.25 12 23.25 23.25 18.213 23.25 12 18.213.75 12 .75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandEcommerceWordpress = { render };
export {
  brandEcommerceWordpress as default,
  render
};
//# sourceMappingURL=brand-ecommerce-wordpress.svg.js.map
